/* AHRIN — Wishlist / Compare / Share + Dock renderer (stable build) */
(function () {
  if (window.__ahrinWC) return;
  window.__ahrinWC = true;

  // --- Canonical header cart-count updater (bubble-only) ---
  window.refreshCartCount = async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) return;
      const { item_count } = await r.json();
      const count = Number(item_count || 0);

      // Raw numbers some themes expose
      document.querySelectorAll('[data-cart-count],[data-cart-count-text]').forEach(el => {
        el.textContent = String(count);
      });

      // Dawn-style bubble numbers
      document.querySelectorAll(
        '.cart-count-bubble span[aria-hidden="true"],' +
        '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"],' +
        '.cart-count-bubble__count'
      ).forEach(el => { el.textContent = String(count); });

      // Show/hide the bubble wrapper
      document.querySelectorAll('.cart-count-bubble').forEach(b => {
        b.classList.toggle('hidden', count === 0);
        b.toggleAttribute?.('hidden', count === 0);
      });

      // Broadcast for any listeners
      document.dispatchEvent(new CustomEvent('ahrin:cart:count', { detail: { count } }));
    } catch {}
  };

  // Back-compat alias
  window.updateCartBubble = window.refreshCartCount;

  /* ---------------- Core keys / helpers ---------------- */
  const KEY_W = 'ahrin:wishlist';
  const KEY_C = 'ahrin:compare';
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const cssEscape = (window.CSS && CSS.escape) ? CSS.escape : s => String(s).replace(/[^a-zA-Z0-9_\-]/g, '\\$&');

  const read  = k => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch { return []; } };
  const write = (k, a) => localStorage.setItem(k, JSON.stringify([...new Set(a)]));
  const handleFrom = el => el.closest('[data-wc-buttons]')?.dataset.productHandle || '';

  /* --- AHRIN: screen-reader live announcer --- */
  function srAnnounce(msg){
    let node = document.getElementById('ahrin-live');
    if(!node){
      node = document.createElement('div');
      node.id = 'ahrin-live';
      node.setAttribute('aria-live','polite');
      node.setAttribute('aria-atomic','true');
      Object.assign(node.style,{
        position:'absolute',width:'1px',height:'1px',margin:'-1px',border:'0',padding:'0',
        clip:'rect(0 0 0 0)',overflow:'hidden',whiteSpace:'nowrap'
      });
      document.body.appendChild(node);
    }
    node.textContent = '';
    setTimeout(() => { node.textContent = String(msg || ''); }, 10);
  }

  /* --- AHRIN: tiny toast UI (one implementation only) --- */
  function toast(msg){
    let el = document.getElementById('ahrin-toast');
    if(!el){
      el = document.createElement('div');
      el.id = 'ahrin-toast';
      Object.assign(el.style,{
        position:'fixed', right:'16px', bottom:'16px',
        background:'#111', color:'#fff', padding:'10px 12px',
        borderRadius:'10px', fontSize:'14px', zIndex:'99999',
        opacity:'0', transform:'translateY(8px)',
        transition:'opacity .18s ease, transform .18s ease'
      });
      document.body.appendChild(el);
    }
    el.textContent = String(msg || '');
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
    clearTimeout(el._t);
    el._t = setTimeout(()=>{ el.style.opacity='0'; el.style.transform='translateY(8px)'; }, 1400);
    try { srAnnounce(String(msg||'')); } catch(_) {}
  }

  const labelForKey = key => key === KEY_W ? 'wishlist' : 'compare';

  function setBtnLabel(btn, on){
    const type = btn.dataset.wc;
    let txt = '';
    if (type === 'wish')  txt = on ? 'Remove from wishlist' : 'Add to wishlist';
    if (type === 'comp')  txt = on ? 'Remove from compare' : 'Add to compare';
    if (type === 'share') txt = 'Share this product';
    if (txt){ btn.setAttribute('aria-label', txt); btn.title = txt; }
  }
  function paintBtn(btn, on){
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    setBtnLabel(btn, on);
  }

  function syncHandle(handle){
    const wishOn = read(KEY_W).includes(handle);
    const compOn = read(KEY_C).includes(handle);
    $$(`[data-wc-buttons][data-product-handle="${cssEscape(handle)}"] [data-wc]`).forEach(btn => {
      if (btn.dataset.wc === 'wish')      paintBtn(btn, wishOn);
      else if (btn.dataset.wc === 'comp') paintBtn(btn, compOn);
    });
  }

  function updateCountsUI(){
    const w = read(KEY_W).length;
    const c = read(KEY_C).length;
    $$('[data-wc-count="wish"]').forEach(el => { el.hidden = !w; el.textContent = String(w); });
    $$('[data-wc-count="comp"]').forEach(el => { el.hidden = !c; el.textContent = String(c); });
  }
  function updateFab(){
    const total = read(KEY_W).length + read(KEY_C).length;
    $$('[data-fab-badge]').forEach(b => {
      b.style.display = total > 0 ? 'inline-block' : 'none';
      b.hidden = total === 0;
      b.textContent = String(total);
    });
    updateCountsUI();
  }
  function syncAll(){
    const seen = new Set();
    $$('[data-wc-buttons][data-product-handle]').forEach(wrap => {
      const h = wrap.dataset.productHandle;
      if (h && !seen.has(h)) { seen.add(h); syncHandle(h); }
    });
    updateFab();
    $$('[data-wc="share"]').forEach(b => setBtnLabel(b, false));
  }

  function toggleList(key, handle){
    const arr = read(key);
    const i = arr.indexOf(handle);
    const adding = i === -1;
    if (adding) arr.push(handle);
    else arr.splice(i, 1);
    write(key, arr);
    updateFab();
    syncHandle(handle);
    document.dispatchEvent(new CustomEvent('ahrin:lists:changed', { detail: { key, handle } }));
    const msg = `${adding ? 'Added to' : 'Removed from'} ${labelForKey(key)}. ${arr.length} item${arr.length === 1 ? '' : 's'} total.`;
    toast(msg);
  }

  /* ================= Share / Restore lists ================= */

  // Build a sharable URL using ?wl=handle1,handle2&cmp=...
  function buildShareURL(partial){
    const wl = (partial?.wl ?? read(KEY_W)).filter(Boolean);
    const cp = (partial?.cp ?? read(KEY_C)).filter(Boolean);
    const p = new URLSearchParams();
    if (wl.length) p.set('wl', wl.join(','));
    if (cp.length) p.set('cmp', cp.join(','));
    const qs = p.toString();
    return `${location.origin}${location.pathname}${qs ? '?' + qs : ''}`;
  }

  async function shareLists(partial){
    const url = buildShareURL(partial);
    const title = document.title.replace(/\s*\|.*/,'');
    if (navigator.share){
      try { await navigator.share({ title, url }); return; } catch(_) {}
    }
    try { await navigator.clipboard.writeText(url); toast('Share link copied'); }
    catch { toast(url); }
  }

  // Restore lists if the visitor opens a link with wl/cmp params
  function restoreFromQuery(){
    const qs = new URLSearchParams(location.search);
    const wlIn = (qs.get('wl')||'').split(',').filter(Boolean);
    const cpIn = (qs.get('cmp')||'').split(',').filter(Boolean);
    if (!wlIn.length && !cpIn.length) return false;

    const wl = Array.from(new Set([ ...read(KEY_W), ...wlIn ]));
    const cp = Array.from(new Set([ ...read(KEY_C), ...cpIn ]));
    write(KEY_W, wl);
    write(KEY_C, cp);

    // Clean the URL so refresh won't re-import
    try {
      qs.delete('wl'); qs.delete('cmp');
      const clean = `${location.pathname}${qs.toString() ? '?' + qs.toString() : ''}${location.hash}`;
      history.replaceState({}, '', clean);
    } catch {}

    document.dispatchEvent(new CustomEvent('ahrin:lists:changed', { detail:{ wlCount: wl.length, cpCount: cp.length }}));
    updateFab();
    toast('Lists restored');
    return true;
  }

  
  
  
  /* === AH-RIN • Share current page (menu + fallback page) ================ */
function sharePage() {
  const url = location.href;
  const title = document.title.replace(/\s*\|.*/,''); // strip " | Your Store"
  // Native share (mobile) -> fallback to clipboard -> fallback prompt
  if (navigator.share) {
    navigator.share({ title, url }).catch(() => {});    // user can cancel; ignore
  } else if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url)
      .then(() => toast('Page link copied'))
      .catch(() => { try { prompt('Copy this link:', url); } catch(_) {} });
  } else {
    try { prompt('Copy this link:', url); } catch(_) {}
  }
}
/* ===================================================================== */

  
  
  
  
  
  
  
  
  // Global “Share lists” button (add anywhere): <button data-share-lists>
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-share-lists]');
    if (!btn) return;
    e.preventDefault();
    shareLists();
  });

  /* ----- keep stretched-link from stealing the click ----- */
  document.addEventListener('pointerdown', e => {
    if (e.target.closest('[data-wc]')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('touchstart', e => {
    if (e.target.closest('[data-wc]')) { e.preventDefault(); e.stopPropagation(); }
  }, { capture: true, passive: false });

  /* ---------------- Button click handlers ---------------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wc]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const handle = handleFrom(btn);
    if (!handle) return;
    const type = btn.dataset.wc;

    // Existing per-product share (PDP / cards)
    if (type === 'share') {
      const url = `${location.origin}/products/${handle}`;
      if (navigator.share) { navigator.share({ title: document.title, url }).catch(() => {}); }
      else { navigator.clipboard?.writeText(url); alert('Product link copied'); }
      return;
    }
    const key = (type === 'wish') ? KEY_W : KEY_C;
    toggleList(key, handle);
  });
  

// Share: current page when clicking a "Share" menu link
// Works for #share-page, /#share-page, /pages/share and /pages/share?pb=...
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href]');
  if (!a) return;

  const href = a.getAttribute('href') || '';
  const isShareLink =
    href === '#share-page' ||
    href === '/#share-page' ||
    href.startsWith('/pages/share');

  if (!isShareLink) return;

  e.preventDefault();
  try { a.blur && a.blur(); } catch(_) {}

  sharePage();
});


document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href*="/pages/share"]');
  if (!a) return;
  e.preventDefault();
  sharePage();
});




  /* === Inject mini counters into existing menu links (no Liquid edits) === */
  function ensureNavCounters(){
    $$('a[href*="/pages/wishlist"]').forEach(a => {
      if (!a.querySelector('[data-wc-count="wish"]')) {
        const s = document.createElement('span');
        s.className = 'ahrin-navcount';
        s.setAttribute('data-wc-count','wish');
        s.hidden = true; s.textContent = '0';
        a.appendChild(s);
        if (!a.style.position) a.style.position = 'relative';
      }
    });
    $$('a[href*="/pages/compare"]').forEach(a => {
      if (!a.querySelector('[data-wc-count="comp"]')) {
        const s = document.createElement('span');
        s.className = 'ahrin-navcount';
        s.setAttribute('data-wc-count','comp');
        s.hidden = true; s.textContent = '0';
        a.appendChild(s);
        if (!a.style.position) a.style.position = 'relative';
      }
    });
  }

  function init(){
    ensureNavCounters();
    restoreFromQuery();          // <— NEW: import from ?wl=&cmp=
    requestAnimationFrame(syncAll);
  }
  document.addEventListener('DOMContentLoaded', init);

  function primeCartBubble() {
    window.refreshCartCount?.();
  }
  if (document.readyState !== 'loading') {
    setTimeout(primeCartBubble, 0);           // first paint
  } else {
    document.addEventListener('DOMContentLoaded', primeCartBubble, { once: true });
  }
  // If the header is re-rendered via Shopify section swaps, prime again
  document.addEventListener('shopify:section:load', primeCartBubble);

  /* ======================= Dock renderer ======================= */
  const DOCK    = document.getElementById('ahrin-dock');
  const CONTENT = DOCK?.querySelector('[data-dock-content]');
  const FAB     = document.querySelector('[data-ahrin-fab]');
  FAB?.classList.remove('is-hidden');

  /* Accessibility helpers */
  let _lastFocus = null;
  function getFocusables(container){
    return Array.from(container.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(el => {
      const r = el.getBoundingClientRect();
      return (r.width || r.height) && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function trapKeydown(e){
    if (DOCK?.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape'){ e.preventDefault(); setDock(false); return; }
    if (e.key !== 'Tab') return;
    const panel = DOCK.querySelector('.ahrin-dock__panel');
    const f = getFocusables(panel || DOCK); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  function setDock(open){
    if (!DOCK) return;
    DOCK.setAttribute('aria-hidden', open ? 'false' : 'true');
    FAB?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('dock-open', open);
    document.body.classList.toggle('dock-open', open);

    if (open){
      _lastFocus = document.activeElement;
      const panel = DOCK.querySelector('.ahrin-dock__panel');
      panel?.setAttribute('tabindex','-1');
      renderDock();
      setTimeout(() => {
        const f = getFocusables(panel || DOCK);
        (f[0] || panel || DOCK).focus({ preventScroll: true });
      }, 0);
      document.addEventListener('keydown', trapKeydown);
    } else {
      document.removeEventListener('keydown', trapKeydown);
      (_lastFocus || FAB)?.focus?.({ preventScroll: true });
    }
  }

  FAB?.addEventListener('click', () => {
    const isOpen = DOCK?.getAttribute('aria-hidden') === 'false';
    setDock(!isOpen);
  });

  DOCK?.addEventListener('click', (e) => {
    // 1) explicit close buttons/links
    if (e.target.closest('[data-dock-close]')) return setDock(false);

    // 2) click on the backdrop (outside the panel)
    const panel =
      DOCK.querySelector('.ahrin-dock__panel') ||   // preferred
      DOCK.querySelector('.ahrin-dock__sheet') ||   // fallback
      DOCK.firstElementChild;                       // last-resort fallback

    if (panel && !panel.contains(e.target)) return setDock(false);
  });

  /* ---- fetch + cache product JSON for handles ---- */
  const cache = new Map();
  async function loadProduct(handle){
    if (cache.has(handle)) return cache.get(handle);
    const url = `/products/${encodeURIComponent(handle)}.js`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('load-failed');
      const p = await res.json();
      cache.set(handle, p);
      return p;
    } catch { return null; }
  }

  function money(cents){
    try { if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}"); }
    } catch {}
    return (Number(cents || 0) / 100).toFixed(2);
  }

  /* ---- Add-to-cart helpers (AJAX) ---- */
  async function addToCart(variantId, qty = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      });
      if (!res.ok) throw new Error('add-failed');

      // refresh the HEADER cart bubble
      await window.refreshCartCount?.();
      try { window.toast?.('Added to cart.'); } catch (_) {}
      return true;
    } catch (e) {
      try { window.toast?.('Could not add to cart. Please try again.'); } catch (_) {}
      return false;
    }
  }

  async function addManyToCart(variantIds = [], qty = 1){
    if (!variantIds.length) return false;
    const items = variantIds.map(id => ({ id: Number(id), quantity: qty }));

    try{
      const before = await fetchCart();
      const beforeCount = Number(before?.item_count || 0);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('add-failed');

      await window.refreshCartCount?.();

      const after = await fetchCart();
      const afterCount = Number(after?.item_count || 0);
      const diff = Math.max(0, afterCount - beforeCount);

      if (diff === 0) { toast('No items were added (possibly sold out/options required).'); return false; }
      if (diff !== items.length) toast(`Added ${diff} of ${items.length} items (some unavailable).`);
      else toast(`Added ${diff} item${diff===1?'':'s'} to cart.`);
      return true;
    } catch(e){
      toast('Could not add items to cart.');
      return false;
    }
  }

  async function fetchCart(){
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      return r.ok ? r.json() : null;
    } catch { return null; }
  }

  /* ---- Dock section HTML ---- */
  async function sectionHTML(title, handles, key){
    if (!handles.length) return '';

    const prods = await Promise.all(handles.map(loadProduct));
    const items = prods.map((p, i) => {
      const handle = handles[i];
      if (!p) return '';
      const img = (p.images && p.images[0]) || p.featured_image || {};
      const src = (typeof img === 'string' ? img : img.src) || '';
      const priceCents = p.price || (p.variants && p.variants[0] && p.variants[0].price) || 0;
      const imgSrc = src ? src : '//cdn.shopify.com/s/assets/no-image-256-79048d2dec8c67f5fa5f492ade9c3e70.svg';

      const variants = Array.isArray(p.variants) ? p.variants : [];
      const available = variants.filter(v => v && v.available);

      let actions = '';
      if (!variants.length || !available.length){
        actions = `<button class="ahrin-line__add is-disabled" type="button" disabled>Sold out</button>`;
      } else if (available.length === 1){
        const v = available[0];
        actions = `<button class="ahrin-line__add" type="button" data-add data-vid="${v.id}" aria-label="Add to cart">Add</button>`;
      } else {
        actions = `<a class="ahrin-line__opts" href="/products/${handle}">Choose options</a>`;
      }

      return `
        <div class="ahrin-line" data-handle="${handle}" data-key="${key}">
          <a class="ahrin-line__img" href="/products/${handle}" aria-hidden="true" tabindex="-1">
            <img src="${imgSrc}" alt="">
          </a>
          <div class="ahrin-line__meta">
            <a class="ahrin-line__title" href="/products/${handle}">${p.title}</a>
            <div class="ahrin-line__price">${priceCents ? money(priceCents) : ''}</div>
          </div>
          <div class="ahrin-line__actions">${actions}</div>
          <button class="ahrin-line__rm" type="button" data-rm data-handle="${handle}" data-key="${key}" aria-label="Remove">×</button>
        </div>`;
    }).join('');

    return `
      <section class="ahrin-section" data-key="${key}">
        <div class="ahrin-section__title">
          <h3>${title}</h3>
          <span class="ahrin-count">${handles.length}</span>

          <button type="button"
            class="ahrin-ghost-btn"
            data-add-all
            data-key="${key}"
            aria-label="Add all ${title.toLowerCase()} to cart">
            Add all
          </button>

          <button type="button"
            class="ahrin-ghost-btn"
            data-clear-list
            data-key="${key}"
            aria-label="Clear all ${title.toLowerCase()}">
            Clear all
          </button>
        </div>
        <div class="ahrin-list">${items}</div>
      </section>`;
  }

  function updateAddAllDisabled(){
    $$('[data-add-all]').forEach(btn => {
      const key = btn.dataset.key;
      const handles = read(key);
      btn.disabled = !handles.length;
    });
  }

  async function renderDock(){
    if (!DOCK || !CONTENT) return;
    const wish = read(KEY_W);
    const comp = read(KEY_C);
    if (!wish.length && !comp.length) {
      CONTENT.innerHTML = `<p class="ahrin-dock__empty">No items yet.</p>`;
      return;
    }
    CONTENT.innerHTML = `<p style="padding:12px;opacity:.6">Loading…</p>`;
    const [wHTML, cHTML] = await Promise.all([
      sectionHTML('Wishlist', wish, KEY_W),
      sectionHTML('Compare',  comp, KEY_C)
    ]);
    CONTENT.innerHTML = (wHTML + cHTML) || `<p class="ahrin-dock__empty">No items yet.</p>`;
    try { updateAddAllDisabled(); } catch(_) {}
  }

  /* ---- Clear all inside each Dock section ---- */
  document.addEventListener('click', (e) => {
    const clr = e.target.closest('[data-clear-list]');
    if (!clr) return;
    e.preventDefault();
    const key   = clr.dataset.key;
    const count = read(key).length;
    if (!count) return;
    if (!confirm(`Clear all items in ${labelForKey(key)}?`)) return;
    write(key, []);
    updateFab();
    renderDock();
    document.dispatchEvent(new CustomEvent('ahrin:lists:changed', { detail: { key } }));
    const msg = `Cleared ${count} item${count === 1 ? '' : 's'} from ${labelForKey(key)}.`;
    toast(msg);
  });

  /* ---- Remove a single line item inside the dock ---- */
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-rm]');
    if (!rm) return;
    e.preventDefault();
    const { handle, key } = rm.dataset;
    toggleList(key, handle);
    rm.closest('.ahrin-line')?.remove();
    if (!read(key).length) renderDock();
  });

  /* ---- Quick add-to-cart (single) from the dock ---- */
  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-add]');
    if (!add) return;
    e.preventDefault();
    if (add.classList.contains('is-busy')) return;
    const vid = Number(add.dataset.vid);
    if (!vid) return;
    add.classList.add('is-busy');
    await addToCart(vid, 1);
    add.classList.remove('is-busy');
  });

  /* ---- Add all in a dock section ---- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-all]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;

    const key = btn.dataset.key;
    const handles = read(key);
    const prods = await Promise.all(handles.map(loadProduct));

    const vids = [];
    prods.forEach(p => {
      const v = (p?.variants || []).find(v => v && v.available);
      if (v) vids.push(v.id);
    });
    if (vids.length) await addManyToCart(vids, 1);

    btn.disabled = false;
  });

  // Keep the open dock in sync when lists change elsewhere
  document.addEventListener('ahrin:lists:changed', () => {
    if (DOCK?.getAttribute('aria-hidden') === 'false') renderDock();
  });

  /* Expose simple helpers for manual testing */
  window.AHRIN = Object.assign(window.AHRIN || {}, {
    openDock:  () => setDock(true),
    closeDock: () => setDock(false),
    shareLists, buildShareURL
  });

  /* AHRIN — Make card image navigate to the product page (safe fallback) */
  (function () {
    if (window.__ahrinImageClickPatch) return;
    window.__ahrinImageClickPatch = true;

    function findProductLink(fromEl) {
      const card = fromEl.closest('.card-wrapper, .card, .grid__item');
      return card ? card.querySelector('.full-unstyled-link') : null;
    }
    function go(e, a) {
      const href = a && a.getAttribute('href'); if (!href) return;
      if (e.button === 1 || e.ctrlKey || e.metaKey) window.open(href, '_blank');
      else location.assign(href);
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-wc], .wc-btn, button')) return;
      const media = e.target.closest('.card__media, .media'); if (!media) return;
      const a = findProductLink(media); if (a) go(e, a);
    }, true);
  })();

})();
